import { BarChart2, FileUp, FolderTree, LayoutDashboard, ListFilter } from 'lucide-react'
import type { LucideIcon } from 'lucide-react'
import type { TranslationKeys } from '@/shared/i18n/locales/en'

export const SIDEBAR_WIDTH = 240
export const SIDEBAR_COLLAPSED_WIDTH = 64

export interface NavItem {
    /** i18n key — must be a key of TranslationKeys */
    labelKey: keyof TranslationKeys
    path: string
    icon: LucideIcon
}

/**
 * Navigation items for the household finance app.
 * Each entry appears in both the desktop sidebar and mobile bottom nav.
 */
export const NAV_ITEMS: NavItem[] = [
    { labelKey: 'navHome',         path: '/',             icon: LayoutDashboard },
    { labelKey: 'navTransactions', path: '/transactions', icon: BarChart2 },
    { labelKey: 'navImport',       path: '/import',       icon: FileUp },
    { labelKey: 'navCategories',   path: '/categories',   icon: FolderTree },
    { labelKey: 'navRules',        path: '/rules',        icon: ListFilter },
]
